export default "__VITE_ASSET__D6pvx18U__"